export class PoliticaPrivacidade {
    nomeUsuario: string;    
    aceitePoliticaPrivacidade: boolean = false;
    aceitePoliticaPrivacidadeSIC: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/_models/politica-privacidade.ts